module.exports = __webpack_public_path__ + "static/media/Clock_type_dial_meter.97a6cf8f.jpg";